module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "response-container"
  }, [_c('h1', [_vm._v("PCS 02 API Response")]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Interface Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": "",
      "id": "interfaceName",
      "name": "interfaceName"
    },
    model: {
      value: (_vm.interfaceName),
      callback: function($$v) {
        _vm.interfaceName = $$v
      },
      expression: "interfaceName"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("SB Number (7005705)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "sbNumber",
      "name": "sbNumber"
    },
    model: {
      value: (_vm.sbNumber),
      callback: function($$v) {
        _vm.sbNumber = $$v
      },
      expression: "sbNumber"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [(_vm.sbNumber && _vm.interfaceName) ? _c('b-button', {
    staticStyle: {
      "font-size": "0.675rem",
      "margin-left": "5px",
      "margin-bottom": "4px"
    },
    attrs: {
      "size": "sm",
      "variant": "info"
    },
    on: {
      "click": function($event) {
        _vm.getAllPCS02Func()
      }
    }
  }, [_vm._v("Fetch")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), (!_vm.getAllPcs02 ||
    _vm.getAllPcs02.response.length <= 0 ||
    _vm.getAllPcs02.responseStatus === 'not found'
  ) ? _c('div', [_c('b', {
    staticClass: "text-danger"
  }, [_vm._v("No data found.")])]) : _c('div', [_c('b-row', [_c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', {
    staticClass: "text-success"
  }, [_vm._v("Response Status: " + _vm._s(_vm.getAllPcs02.responseStatus))])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Gross Quantity:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs02.response[0].grossQuantity) + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("SB No:")]), _vm._v(" " + _vm._s(_vm.getAllPcs02.response[0].sbNo) + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Nature of Cargo:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs02.response[0].natureOfCargo))]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Port of Origin:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs02.response[0].portOfOrigin))]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Port of Destination:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs02.response[0].portOfDestination))]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Unit of Quantity:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs02.response[0].unitOfQuantity))]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Total No of Packages:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs02.response[0].totalNoOfPackages))]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("CHA Code:")]), _vm._v(" " + _vm._s(_vm.getAllPcs02.response[0].chaCode))]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("SB Date:")]), _vm._v(" " + _vm._s(_vm.getAllPcs02.response[0].sbDate))])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f5ac86d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/ulip/PCS02_ResponseDisplay.vue
// module id = 2784
// module chunks = 0